/**
 *  Search Controller
 *  Main functionality for how filters swap depending on cruise type can be found on ParentView
 */

var ParentView = require("../../commons/modules/modify-search-widget");

let SearchController = ParentView.extend({
  events: function() {
    var parentEvents = _.result(ParentView.prototype, "events");

    return _.extend(
      {
        "click [data-value-trigger]": "scrollUp",
        "click [data-reset]": "resetComponent",
        "click [data-reset-all]": "resetAll",
        "click [data-param-close]": "close"
      },
      parentEvents
    );
  },

  initialize: function(options) {
    this.componentList = this.$el.find("[data-component]");
    this.constructor.__super__.initialize.call(this, options);

    this.$el.on("submit", e => {
      sessionStorage.removeItem("resultViewMode");
    });
  },

  scrollUp: function() {
    if (
      navigator.userAgent.match(/Android/i) === null &&
      navigator.userAgent.match(/iPhone/i) === null
    ) {
      var $container = $("[data-search-container]");
      if ($container.offset()) {
        $("html,body").animate(
          { scrollTop: $container.offset().top - 150 },
          "slow"
        );
      }
    }
  },

  // Reset the component targeted and it's container collapser
  resetComponent: function(e) {
    const target = e.currentTarget.dataset["reset"];
    this.componentList.each(function() {
      this.dataset["component"] == target
        ? $(this)
            .component()
            .reset()
        : false;
    });
  },

  // Reset all components
  resetAll: function(e) {
    this.componentList.each(function() {
      $(this)
        .component()
        .reset();
    });
  },

  close: function(e) {
    $(e.currentTarget)
      .closest('[data-component="collapser"]')
      .component()
      .close();
  }
});

module.exports = SearchController;
